// src/components/Ouvidoria/OuvidoriaUserView.js
import React, { useState } from 'react';
import { db } from '../../firebaseConfig';
import { collection, addDoc, serverTimestamp } from 'firebase/firestore';
import { FaPaperPlane, FaLock, FaUserSecret, FaCheckCircle } from 'react-icons/fa';
import PolicyModal from './PolicyModal'; // Importa o novo componente de política

const OuvidoriaUserView = ({ userData }) => {
  const [message, setMessage] = useState('');
  const [category, setCategory] = useState('sugestao');
  const [isAnonymous, setIsAnonymous] = useState(true);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [error, setError] = useState('');
  const [successInfo, setSuccessInfo] = useState({ show: false, protocol: null });
  const [isPolicyVisible, setIsPolicyVisible] = useState(false); // Estado para controlar a visibilidade do modal

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (message.trim().length < 10) {
      setError('Por favor, escreva uma mensagem com pelo menos 10 caracteres.');
      return;
    }

    setIsSubmitting(true);
    setError('');
    setSuccessInfo({ show: false, protocol: null });

    try {
      const submissionData = {
        message,
        category,
        isAnonymous,
        userId: userData.id,
        userName: isAnonymous ? 'Anônimo' : userData.name,
        userDepartment: isAnonymous ? 'N/A' : userData.departamento,
        createdAt: serverTimestamp(),
        status: 'novo',
        replies: [],
      };

      const ouvidoriaCollectionRef = collection(db, 'Empresas', userData.empresa_id, 'ouvidoria');
      const docRef = await addDoc(ouvidoriaCollectionRef, submissionData);

      setSuccessInfo({ show: true, protocol: docRef.id });

      // Limpa o formulário após o envio
      setMessage('');
      setCategory('sugestao');
      setIsAnonymous(true);

    } catch (err) {
      console.error("Erro ao enviar manifestação:", err);
      setError('Ocorreu um erro ao enviar sua mensagem. Tente novamente.');
    } finally {
      setIsSubmitting(false);
    }
  };

  if (successInfo.show) {
    return (
      <div className="ouvidoria-form-card success-message">
        <FaCheckCircle size={50} className="success-icon" />
        <h3>Mensagem Enviada!</h3>
        <p>Sua manifestação foi recebida com sucesso e de forma confidencial.</p>
        <div className="protocol-box">
          <strong>Guarde seu número de protocolo para consultar a resposta:</strong>
          <span>{successInfo.protocol}</span>
          <small>Este é o único meio de acompanhar sua manifestação anônima.</small>
        </div>
        <button onClick={() => setSuccessInfo({ show: false, protocol: null })} className="btn-primary">
          Enviar Nova Mensagem
        </button>
      </div>
    );
  }

  return (
    <>
      <div className="ouvidoria-form-card">
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label htmlFor="category">Qual o tipo da sua mensagem?</label>
            <select id="category" value={category} onChange={(e) => setCategory(e.target.value)} className="form-control">
              <option value="sugestao">Sugestão ou Ideia</option>
              <option value="elogio">Elogio</option>
              <option value="duvida">Dúvida</option>
              <option value="reclamacao">Reclamação ou Problema</option>
              <option value="outro">Outro Assunto</option>
            </select>
          </div>

          <div className="form-group">
            <label htmlFor="message">Sua mensagem:</label>
            <textarea
              id="message"
              rows="8"
              value={message}
              onChange={(e) => setMessage(e.target.value)}
              placeholder="Escreva sua mensagem aqui..."
              className="form-control"
              required
            />
          </div>

          <div className="form-group-toggle">
            <label htmlFor="anonymous-toggle" className="toggle-label">
              <input
                id="anonymous-toggle"
                type="checkbox"
                checked={isAnonymous}
                onChange={(e) => setIsAnonymous(e.target.checked)}
                className="toggle-checkbox"
              />
              <span className="toggle-switch"></span>
              <span className="toggle-text">Enviar como anônimo</span>
            </label>
          </div>

          <div className="anonymous-info">
            {isAnonymous ? (
              <p><FaUserSecret /> Sua identidade não será revelada. Você receberá um protocolo para consultar a resposta.</p>
            ) : (
              <p><FaPaperPlane /> Seu nome e departamento serão visíveis para o time de People.</p>
            )}
          </div>

          {error && <p className="error-message">{error}</p>}

          <button type="submit" className="btn-primary btn-submit-ouvidoria" disabled={isSubmitting}>
            {isSubmitting ? 'Enviando...' : 'Enviar Mensagem'}
          </button>
        </form>
        
        <div className="policy-link-container">
            <FaLock /> Ao enviar, você concorda com nossa <button type="button" onClick={() => setIsPolicyVisible(true)} className="link-button">Política de Uso e Confidencialidade</button>.
        </div>
      </div>
      
      <PolicyModal isOpen={isPolicyVisible} onClose={() => setIsPolicyVisible(false)} />
    </>
  );
};

export default OuvidoriaUserView;